import { formatKm } from '../domain/distance';
import type { TimelineSegment } from '../domain/models';
import { formatDateTime } from '../domain/time';
import { ConfidenceBadge } from './ConfidenceBadge';

export function SegmentTable({ segments }: { segments: TimelineSegment[] }) {
  if (segments.length === 0) {
    return <div className="surface map-empty">移動区間はありません</div>;
  }

  return (
    <div className="surface table-wrap">
      <table>
        <thead>
          <tr>
            <th>開始</th>
            <th>終了</th>
            <th>距離</th>
            <th>時間</th>
            <th>推定手段</th>
            <th>確度</th>
            <th>source</th>
          </tr>
        </thead>
        <tbody>
          {segments.map((segment) => (
            <tr key={segment.id}>
              <td>{formatDateTime(segment.startTime)}</td>
              <td>{formatDateTime(segment.endTime)}</td>
              <td>{formatKm(segment.distanceMeters)} km</td>
              <td>{Math.round(segment.durationMinutes)} 分</td>
              <td>{segment.inferredMode ?? 'unknown'}</td>
              <td>
                <ConfidenceBadge confidence={segment.confidence} />
              </td>
              <td>{segment.source}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
